#import "../fragments/peep-business-card-info-fragment.graphql"

mutation EditContactBusinessCardField($input: EavPatchInput!) {
    contactEavPatch(input: $input) {
        contact {
            ...PeepBusinessCardInfoFragment
        }
    }
}
